export default function domIsOverflow() {
    return window.innerWidth > document.body.clientWidth;
}
//# sourceMappingURL=domIsOverFlow.js.map